import React, { useEffect } from 'react';
import { ServiceIntegration } from '../types';
import { useFetchIntegration, useSaveIntegration } from './hooks';
import { Retry } from '@src/components/common';
import EditCreateForm from './IntegrationForm';
import { useAtomValue } from 'jotai';
import { createIntegrationAtom, partnerAtom } from '../atoms';
import { Form } from 'antd';

const ServiceIntegrationEdit = ({ configId }) => {
  const createIntegration = useAtomValue(createIntegrationAtom);
  const partner = useAtomValue(partnerAtom);
  const { mutate: saveMutate, isLoading: isSaving } = useSaveIntegration();
  const [form] = Form.useForm();

  useEffect(() => {
    return () => {
      form.resetFields();
    };
  }, []);

  const defaultIntegrationData: ServiceIntegration = {
    name: '',
    emails: '',
    partnerId: partner?.partnerId || null,
    partnerName: partner?.name || null,
    configId: null,
  };

  const { data = {}, refetch, isFetching, isError } = useFetchIntegration({ configId });

  const integrationData = createIntegration ? defaultIntegrationData : data;

  return (
    <Retry
      isLoading={isFetching || isSaving}
      fetchData={refetch}
      showError={isError}
      mountChildAlways={false}
    >
      <EditCreateForm
        integrationData={integrationData}
        form={form}
        onSave={saveMutate}
        isSaving={isSaving}
      />
    </Retry>
  );
};

export default ServiceIntegrationEdit;
